import { Radio, RadioGroup } from "@/components/base/radio-group";
import { TeamNames } from "@/components/teams/names";
import type { PlayerProfile } from "@/db/schema";
import type { PoolTeamStats } from "@/hooks/matches";

type TeamRadioItem = {
  id: number;
  team: {
    players: {
      profile: Pick<
        PlayerProfile,
        "id" | "preferredName" | "firstName" | "lastName"
      >;
    }[];
  };
  poolTeam: {
    finish: number | null;
    pool: { name: string };
  } | null;
};

export function TeamRadioList({
  teams,
  stats,
  onChange,
  "aria-label": ariaLabel = "Select team",
}: {
  teams: TeamRadioItem[];
  stats?: Map<number, PoolTeamStats>;
  onChange: (teamId: number) => void;
  "aria-label"?: string;
}) {
  return (
    <RadioGroup
      aria-label={ariaLabel}
      onChange={(value) => onChange(Number(value))}
    >
      <div className="flex max-h-96 flex-col overflow-y-scroll">
        <div className="flex w-full items-center gap-2 px-2 py-1 text-xs text-gray-500">
          <span className="w-5 shrink-0" />
          <div className="grid min-w-0 flex-1 grid-cols-[5fr_2fr_2fr_2fr] items-center gap-x-2">
            <span>Team</span>
            <span>Pool</span>
            <span className="text-center">W/L</span>
            <span className="text-center">Diff</span>
          </div>
        </div>
        {teams.map((team) => (
          <Radio
            key={team.id}
            value={team.id.toString()}
            className="w-full rounded-md bg-white p-2"
          >
            <div className="grid min-w-0 flex-1 grid-cols-[5fr_2fr_2fr_2fr] items-center gap-x-2">
              <span className="overflow-x-hidden text-ellipsis whitespace-nowrap">
                <TeamNames
                  players={team.team.players}
                  showFirst={false}
                  separator="/"
                  link={false}
                />
              </span>
              <span>
                {team.poolTeam
                  ? `P${team.poolTeam.pool.name} - ${team.poolTeam.finish}`
                  : "—"}
              </span>
              <span className="text-center">
                {stats?.get(team.id)?.wins.size}/
                {stats?.get(team.id)?.losses.size}
              </span>
              <span className="text-center">
                {stats?.get(team.id)?.totalPointDiff}
              </span>
            </div>
          </Radio>
        ))}
      </div>
    </RadioGroup>
  );
}
